import { AspChartOfAccount, AspChartOfAccountsRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useFetchAspChartOfAccounts() {
  const api = useApi();
  const [fetching, setFetching] = useState(false);
  const [accounts, setAccounts] = useState<AspChartOfAccount[]>([]);

  async function fetchAspChartOfAccounts(params: AspChartOfAccountsRequest) {
    try {
      setFetching(true);
      const res = await api.fetchAspChartOfAccounts(params);
      if (!res.Success) throw new Error(res.ErrorMessage);
      setAccounts(res.Accounts);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetching(false);
    }
  }

  return { fetching, accounts, fetchAspChartOfAccounts };
}
